import React, { FC, useState, useEffect, useRef, useMemo } from 'react';
import {
  Table,
  Justify,
  StatusTip,
  Pagination,
  Button,
  List,
  Dropdown,
  notification,
} from 'tea-component';
import type { TableColumn, PagingQuery } from 'tea-component';
import { RenderType } from '../../types';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import {
  getTopChartsVidoeBenchmarkRankList,
  downloadVidoeBenchmarkMetricsExcel,
} from '../../../../services/pcConsoleBenchmark';
import { filedNameConfig, RevenueSort } from '../../_config/constant';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
// import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import FirstRow from '../../components/FirstRow'
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import NoData from '@/pages/intelligence/components/NoData';
import {
  toFixed0,
  toFixedAddPer,
  handlePriceFormat,
  transTableDataForSearch,
} from '../../_config/utils';
import {
  RevenueValue,
  VidoeBenchmarkRankType,
  RevenueSegmentType,
  GameSegmentType,
} from '../../types';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import {
  dbiBtnLogMes,
  dbiPageLogMes,
} from '@/pages/intelligence/utils/buriedPointCfg';
import { useIntl, history, getLocale } from 'umi';
import moment from 'moment';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import './index.scss';

const { groupable, scrollable } = Table.addons;
const { LoadingTip } = StatusTip;

interface TableContentProps {
  loading: boolean;
  totalNum: number;
  statsBottom: number | null;
  tableList: VidoeBenchmarkRankType[];
  handleFetchTable: (params: { [key: string]: any }) => void;
  apiParams: any;
  tHeaderList: any[];
  revenueValue: RevenueValue;
  checkedMetricsData: any;
  segment: RevenueSegmentType;
  figureSegment: GameSegmentType;
  orderMetric: any;
  page: number;
}

const TableContent: FC<TableContentProps> = (props) => {
  const {
    loading,
    tableList,
    apiParams,
    totalNum,
    handleFetchTable,
    tHeaderList,
    revenueValue,
    orderMetric,
    segment,
    figureSegment,
    page,
    statsBottom
  } = props;

  const benchmarkTable = useRef<HTMLDivElement>(null);

  const [columns, setColumns] = useState<TableColumn[]>([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const defaultPage = 20;
  const [headerGroupList, setHeaderGroupList] = useState([]);
  const handlePagingChange = (pageInfo: PagingQuery) => {
    setPageIndex(pageInfo.pageIndex || 1);
    setPageSize(pageInfo.pageSize || defaultPage);
    handleFetchTable({
      page: pageInfo.pageIndex || 1,
      pageSize: pageInfo?.pageSize || defaultPage,
    });
  };
  const [downloadLoading, setDownloadLoading] = useState(false);
  // const [statsBottom, setStatsBottom] = useState(300);

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const getTableResultList = (id: string) => {
    handleFetchTable({
      page: 1,
      pageSize: pageSize || defaultPage,
      search_game_code: [id],
    });
  };

  const handleClear = () => {
    handleFetchTable({
      page: 1,
      pageSize: pageSize || defaultPage,
      search_game_code: [],
    });
  };

  // 游戏详情
  const gotoDetailByPlat = (plat: string, cvm: any) => {
    if (!plat) return;
    const app_id = plat === 'pc' ? cvm?.pc_id : cvm?.console_id;
    const pathname = getDetailGamePathCommon({
      entityType: plat,
      gameId: app_id,
      tab: 'stats',
      subTab: plat === 'pc' ? 'pcu' : 'digitalrevenue',
    });
    history.push({
      pathname,
    });
  };

  const handleClickPlatGoDetail = (
    cvm: any,
    needPath = false,
    plat?: string,
  ) => {
    const type = plat ? plat : cvm?.platform?.[0] || 'pc';
    const app_id = cvm?.[`${type}_id`] || cvm?.app_id;
    const pathname = getDetailGamePathCommon({
      entityType: type,
      gameId: app_id,
      tab: 'stats',
      subTab: type === 'pc' ? 'pcu' : 'digitalrevenue',
    });
    if (needPath) {
      return pathname;
    } else {
      history.push({
        pathname,
      });
    }
  };

  const onSortChange = (value: SortByItemType) => {
    handleFetchTable({
      order_metric: value.sortMetric,
      order: value.sortVal,
      order_source: segment,
      pageSize: pageSize,
    });
  };

  useEffect(() => {
    setPageIndex(page);
  }, [page]);

  useEffect(() => {
    let columnItem = {
      cover: {
        key: 'rank',
        fixed: 'left',
        width: 350,
        header: () => {
          return (
            <div className="dbi-firstRow-flex">
              <div className="dbi-text-id">#</div>
              <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
            </div>
          );
        },
        render: (cvm: any) => {
          const popupData = cvm?.platform?.map((item) => {
            return {
              text: formatMessage({
                id: item === 'pc' ? 'dbi_pc' : 'dbi_console',
              }),
              value: item === 'pc' ? cvm?.pc_id : cvm?.console_id,
              type: item,
            };
          });
          return (
            <FirstRow
              id={cvm?.rank}
              onClick={() =>
                cvm?.platform?.length === 1 && handleClickPlatGoDetail(cvm)
              }
              clickImageOpenDropdown={ !!(cvm?.platform?.length > 1)}
              rihgtClickToJumpHref={handleClickPlatGoDetail(cvm, true)}
              cvm={{
                img: cvm?.cover,
                gametitle: cvm?.name,
                countryIcon: getCountryFlag(cvm?.publisher_addr),
                text: cvm?.publisher,
                customIcon: cvm?.platform.length ? (
                  <>
                    {cvm?.platform?.map((plat: string) => (
                      <a
                        className="benchmark-table-plat-alink"
                        key={plat}
                        target="_blank"
                        href={handleClickPlatGoDetail(cvm, true, plat)}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <SvgIcon
                          className="benchmark-table-gametype-icon"
                          type={plat === 'pc' ? 'monitor' : 'game'}
                        />
                      </a>
                    ))}
                    <span className="benchmark-table-region-divide"></span>
                  </>
                ) : null,
              }}
              popupData={cvm?.platform?.length === 1 ? [] : popupData}
              onDropdown={(value: any) => {
                handleClickPlatGoDetail(cvm, false, value?.type);
              }}
            />
          );
        },
      },
      action: {
        key: 'Actions',
        header: formatMessage({ id: 'dbi_actions' }),
        align: 'left',
        width: 100,
        render: (cvm) => {
          const hoverList = cvm?.platform?.map((item) => ({
            text: formatMessage({
              id: item === 'pc' ? 'dbi_pc' : 'dbi_console',
            }),
            value: item,
          }));

          return hoverList?.length > 1 ? (
            <Dropdown
              clickClose={true}
              placement="bottom-end"
              button={
                <Button className="dbi-kol-table-btn" type="link">
                  {formatMessage({ id: 'dbi_details' })}
                  <SvgIcon type="arrow-down" />
                </Button>
              }
              appearance="pure"
            >
              <List type="option">
                {hoverList?.map((item: any) => (
                  <List.Item
                    key={item.value}
                    onClick={() => gotoDetailByPlat?.(item?.value, cvm)}
                  >
                    {item.text}
                  </List.Item>
                ))}
              </List>
            </Dropdown>
          ) : (
            <Button
              className="table-link"
              type="link"
              onClick={() =>
                gotoDetailByPlat?.(hoverList?.[0]?.value || 'pc', cvm)
              }
            >
              {formatMessage({ id: 'dbi_details' })}
            </Button>
          );
        },
      },
    };

    let _columnsSim: any = [];
    _columnsSim.push(columnItem.cover);
    // 表头列表固定， 可通过表头+数据实现

    if (segment === 'us_digital_revenue') {
      const config = getRevenueColumnsConfig({
        platform: revenueValue?.platform?.sort(
          (a, b) => RevenueSort?.[a] - RevenueSort?.[b],
        ),
        monetization: revenueValue?.monetization?.sort(
          (a, b) => RevenueSort?.[a] - RevenueSort?.[b],
        ),
        metric_type: revenueValue?.metric_type?.sort(
          (a, b) => RevenueSort?.[a] - RevenueSort?.[b],
        ),
        time_interval: ['bf', 's1y', 's2y', 's3y', 's4y', 's5y', 'af'],
        start_date: revenueValue?.start_date
          ?.map((item) => {
            if (item === 'earliest_data') {
              return 'est';
            }
            if (item === 'release_date') {
              return 'fl';
            }
            return item;
          })
          ?.sort((a, b) => RevenueSort?.[a] - RevenueSort?.[b]),
      });
      setColumns([columnItem.cover, ...config?.columns, columnItem.action]);
      setHeaderGroupList(config?.headerGroupList || []);
    } else {
      tHeaderList?.forEach((_tHead, i) => {
        const _tName =
          locale === 'zh-CN' ? _tHead?.text_zh || _tHead?.text : _tHead?.text;
        const _tValue = _tHead?.value;
        const itemRenderType = _tHead?.renderType
          ? _tHead?.renderType
          : RenderType.VALUE_ONLY; //默认RenderType.VALUE_ONLY
        const itemHasSord = _tHead?.hasSort === false ? false : true; //默认true
        _columnsSim.push({
          key: _tHead?.dataSourceKey + _tHead?.value || i,
          width: tHeaderList?.length < 3 ? 'auto' : _tHead.width || 150,
          header: (
            <div>
              <div className="sort-container">
                {!itemHasSord ? (
                  <div className="dbi-table-header-flex table-header-flex-center">
                    {getDataSourceIcon(_tHead?.dataSourceName) ? ( 
                      <div className="context-flex">
                        <img className="table-header-icon" src={getDataSourceIcon(_tHead?.dataSourceName)}/>
                      </div>
                      ) : '' }
                    <span className="table-header-text">{_tName}</span>
                  </div>
                ) : (
                  <SortBy
                    title={_tName}
                    defaultKey={apiParams?.order_metric}
                    defaultValue={apiParams?.order}
                    svgIcon={getDataSourceIcon(_tHead?.dataSourceName)}
                    onChange={onSortChange}
                    list={[
                      {
                        key: _tValue,
                        sortMetric: _tValue,
                        text: _tName,
                        title: _tName,
                      },
                    ]}
                    svgTip={
                      <DataSourceBubbleInfo
                        dataOfDom={_tName}
                        metricKey={_tHead?.metricKey || _tHead?.value}
                        comesFormDom={
                          <>
                            <img
                              src={getDataSourceIcon(_tHead?.dataSourceName)}
                            />
                            {
                              DATASOURCE_NAME[
                                _tHead?.dataSourceName?.toLowerCase()
                              ]
                            }
                          </>
                        }
                        dataSource={_tHead?.dataSourceName?.toLowerCase()}
                      />
                    }
                  ></SortBy>
                )}
              </div>
            </div>
          ),
          align:
            tHeaderList?.length === 1
              ? 'center'
              : _tHead?.align
              ? _tHead.align
              : 'right',
          render: (cvm) => {
            let sourceList = cvm?.metric_map;
            let source = sourceList[_tValue];
            const _value = source?.value;
            let value = _value;
            if (itemRenderType === RenderType.PRICE) {
              value = handlePriceFormat(value);
            }
            if (value === null || value === undefined || value === '') {
              value = '-';
            }
            //特殊处理：
            if (value === '-') {
              return '-';
            }
            if (
              _tHead.value === 'steam_positive_reviews' ||
              _tHead.value === 'max_price'
            ) {
              return <>{toFixed0(value * 100, 0)}</>;
            }
            if (
              _tHead.value === 'newzoo_avg_d2' ||
              _tHead.value === 'newzoo_avg_d30'
            ) {
              return <>{toFixed0(value * 100, 1)}</>;
            }
            return (
              <>
                {itemRenderType === RenderType.VALUE_ONLY ? (
                  <>{newMathFormat(value, true)}</>
                ) : itemRenderType === RenderType.GROWTH_ONLY ? (
                  <>{toFixedAddPer(value * 100)}</>
                ) : itemRenderType === RenderType.TEXT ? (
                  <>{<EllipsisHover text={value} />}</>
                ) : itemRenderType === RenderType.PRICE ? (
                  <>{Number(value).toFixed(2)}</>
                ) : (
                  <>{value}</>
                )}
              </>
            );
          },
        });
      });
      const steamColumn = [..._columnsSim, columnItem.action];
      setColumns(steamColumn);
      setHeaderGroupList([]);
    }
  }, [
    revenueValue,
    segment,
    tHeaderList,
    orderMetric,
    figureSegment,
    pageSize,
    apiParams.order,
    locale,
  ]);

  const handleDownload = async () => {
    setDownloadLoading(true);
    try {
      const data = await downloadVidoeBenchmarkMetricsExcel({
        ...apiParams,
        select_top: Number(totalNum),
      });
      const aLink = document.createElement('a');
      const blob = new Blob([data]);
      aLink.download = `pc_console_benchmark-${segment}-${moment(
        new Date(),
      ).format('YYYYMMDDHHmmss')}.xlsx`;
      aLink.href = URL.createObjectURL(blob);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
      setDownloadLoading(false);
      const btnMsg = dbiBtnLogMes?.pcConsoleBenchmarkDownloadExcel;
      btnMsg && buriedBtnPoint(btnMsg);
      notification.success({
        description: 'Download Success',
        duration: 3000,
      });
    } catch (error) {
      console.log(error);
      notification.error({
        description: 'Download Failed',
        duration: 3000,
      });
      setDownloadLoading(false);
    }
  };

  const goDigitalRevenue = (plat: string, type: string)=> {
    const metric = type === 'rev' ? 'Digital Revenue': 'Digital Units'
    if(plat === 'pc'){
      history.push(`/intelligence/sourcesMetrics/metrics?pageid=mscience&gameType=pc&metric=${metric}`)
    }

    if(plat === 'console'){
      history.push(`/intelligence/sourcesMetrics/metrics?pageid=mscience&gameType=console&metric=${metric}`)
    }

    if(plat === 'pc+console'){
      history.push(`/intelligence/sourcesMetrics/metrics?pageid=mscience&gameType=pc,console&metric=${metric}`)
    }
  }

  const getRevenueColumnsConfig = (value: RevenueValue) => {
    let headerGroupList: any = [];
    let columns: any = [];
    // Platform 第一层遍历
    value?.platform?.forEach((plat) => {
      // Metric Type 第二层遍历
      value?.metric_type?.forEach((type) => {
        // Monetization 第二层遍历
        value?.monetization?.forEach((monet) => {
          // 表头分组处理
          const segmentName = formatMessage({id: 'dbi_benchmark_us_digital'})
          const platName = formatMessage({ id: filedNameConfig?.[plat] });
          const typeName = formatMessage({ id: filedNameConfig?.[type] });
          const monetName = formatMessage({ id: filedNameConfig?.[monet] });
          const titleNameCh = `${segmentName}${platName}${typeName}(${monetName})`;
          const titleNameEn = `${segmentName} ${platName} ${typeName} (${monetName})`;
          headerGroupList.push({
            key: `${plat}_${monet}_${type}`,
            title: (
              <div style={{ display: 'flex', justifyContent: 'center', color: '#262832' }}>
                <SortBy 
                  title={locale === 'zh-CN'? titleNameCh : titleNameEn} 
                  isNoDropdown={true} 
                  svgIcon={getDataSourceIcon('mscience')}
                  svgTip={
                    <DataSourceBubbleInfo 
                      customActions={()=> goDigitalRevenue(plat, type)}
                      metricKey={typeName}
                      dataOfDom={
                        locale === 'zh-CN'? `${segmentName}${platName}${typeName}`: 
                        `${segmentName} ${platName} ${type === 'rev'? 'revenue': 'units'}`
                      }
                      comesFormDom={
                        <>
                          <img src={getDataSourceIcon('mscience')} />
                          {DATASOURCE_NAME['mscience']}
                        </>
                      } />
                  } />
              </div>
            ),
            algin: 'center',
            children:
              // Start date 两个都选时Earliest date ~ Release date需要放中间
              value?.start_date?.length > 1
                ? [
                    ...['est'].map(
                      (date) => `${plat}_${date}_${type}_${monet}`,
                    ),
                    `${plat}_fl_bf_${type}_${monet}`,
                    ...['fl'].map((date) => `${plat}_${date}_${type}_${monet}`),
                  ]
                : [
                    // 选择Release Date，Earliest Date~Release Date部分的数据在Y1前面
                    ...(value?.start_date.includes('fl')
                      ? [`${plat}_fl_bf_${type}_${monet}`]
                      : []),
                    ...value.start_date?.map(
                      (date) => `${plat}_${date}_${type}_${monet}`,
                    ),
                    // 选择Earliest Date， Earliest Date~Release Date部分的数据在total后面
                    // 本来是est_bf 以Release Date的为准 后台数据是这样的的
                    ...(value?.start_date.includes('est')
                      ? [`${plat}_fl_bf_${type}_${monet}`]
                      : []),
                  ],
          });
          // start_date 第四层遍历
          value?.start_date
            ?.sort((a, b) => a?.localeCompare(b))
            .forEach((date) => {
              const getColumns = (timeList: string[]) => {
                timeList?.forEach((time) => {
                  const keyNames = [
                    `${plat}_${
                      date === 'est' && time === 'bf' ? 'fl' : date
                    }_${time}_${type}_${monet}`,
                    `${filedNameConfig?.[time]}` + '_ratio',
                  ];
                  // Start date 两个都选的时候Earliest date ~ Release date放中间需要删除一个
                  if (
                    !(
                      date === 'est' &&
                      time === 'bf' &&
                      value?.start_date?.length > 1
                    )
                  ) {
                    const targetKey = `${plat}_${
                      date === 'est' && time === 'bf' ? 'fl' : date
                    }_${time}_${type}_${monet}`;
                    columns.push({
                      key: targetKey,
                      align: 'center',
                      header: () => {
                        return (
                          // <CloumsCenter align={'center'}>
                          <SortBy
                            title={formatMessage({
                              id: `${filedNameConfig?.[time]}`,
                            })}
                            defaultKey={apiParams?.order_metric}
                            defaultValue={apiParams?.order}
                            onChange={onSortChange}
                            list={[
                              {
                                key: `${targetKey}`,
                                sortMetric: targetKey,
                                text: formatMessage({id: `${filedNameConfig?.[time]}`}),
                                title: formatMessage({id: `${filedNameConfig?.[time]}`}),
                              },
                            ]}
                          ></SortBy>
                          // </CloumsCenter>
                        );
                      },
                      width: time === 'bf' ? 155 : 120,
                      render: (row: any) => {
                        const value =
                          row?.metric_map?.[
                            `${plat}_${
                              date === 'est' && time === 'bf' ? 'fl' : date
                            }_${time}_${type}_${monet}`
                          ]?.value;
                        return (
                          <div
                            style={{
                              textAlign: 'right',
                            }}
                          >
                            {value ? newMathFormat(value, true) : '-'}
                          </div>
                        );
                      },
                    });
                  }
                });
              };
              //  Earliest date
              if (date === 'est') {
                headerGroupList.push({
                  key: `${plat}_${date}_${type}_${monet}`,
                  title: (
                    <div style={{ textAlign: 'center', color: '#262832' }}>
                      {formatMessage({
                        id: 'dbi_benchmark_start_earliest_date',
                      })}
                    </div>
                  ),
                  algin: 'center',
                  children: value?.time_interval
                    ?.map((time) => `${plat}_${date}_${time}_${type}_${monet}`)
                    ?.filter(
                      (config) =>
                        config !== `${plat}_${date}_bf_${type}_${monet}`,
                    ),
                });
                // 字段遍历顺序
                // 由于time_interval一列删除了 所有time_interval的值暂时可以写死
                getColumns(['s1y', 's2y', 's3y', 's4y', 's5y', 'af', 'bf']);
              }

              if (date === 'fl') {
                //  Release date
                headerGroupList.push({
                  key: `${plat}_${date}_${type}_${monet}`,
                  title: (
                    <div style={{ textAlign: 'center', color: '#262832' }}>
                      {formatMessage({
                        id: 'dbi_benchmark_start_release_date',
                      })}
                    </div>
                  ),
                  algin: 'center',
                  children: value?.time_interval
                    ?.map((time) => `${plat}_${date}_${time}_${type}_${monet}`)
                    ?.filter(
                      (config) =>
                        config !== `${plat}_${date}_bf_${type}_${monet}`,
                    ),
                });
                getColumns(['bf', 's1y', 's2y', 's3y', 's4y', 's5y', 'af']);
              }
            });
        });
      });
    });
    return {
      headerGroupList,
      columns,
    };
  };

  // useEffect(()=> {
  //   if(!loading){
  //     const pcStats =document.getElementById('pcStats');
  
  //     if(pcStats){
  //       const bottom = document.body.clientHeight - pcStats?.getBoundingClientRect().top
        
  //       setStatsBottom( bottom < 300 ? 300 : bottom);
  //     }
  //   }
  // }, [loading])

  return (
    <>
      <Table.ActionPanel
        style={{
          marginTop: segment !== 'us_digital_revenue' ? '-56px' : 0,
          marginBottom: '20px',
        }}
      >
        <Justify
          left={<></>}
          right={
            <>
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <SearchRecent
                  fetchParams={{
                    ...apiParams,
                    page: pageIndex,
                    page_size: pageSize,
                  }}
                  pageLogInfo={dbiPageLogMes?.pcConsoleBenchmark}
                  handleClear={handleClear}
                  getTableResultList={getTableResultList}
                  searchType={'vidoe-benchmark'}
                  searchListApi={getTopChartsVidoeBenchmarkRankList}
                  transTableDataForSearch={transTableDataForSearch}
                  // initSearchInput={!(apiParams?.search_game_code?.length > 0)}
                />
              </div>
              <Button
                className="ns-btn--icon trend-justify-btn"
                icon={loading || downloadLoading ? 'loading' : 'download'}
                loading={loading}
                type="primary"
                onClick={() => handleDownload()}
                disabled={loading}
              />
            </>
          }
        />
      </Table.ActionPanel>
      <CardSlotV2>
        {loading ? (
          <div
            className="dbi-benchmark-table-loading"
            style={{ background: '#fff', height: statsBottom || 300 }}
          >
            <LoadingTip />
          </div>
        ) : tableList.length > 0 ? (
          <div id="pc-benchmark-table" className="dbi-benchmark-table">
            <Table
              ref={benchmarkTable}
              recordKey={'app_id'}
              columns={columns}
              records={tableList}
              className={`dbi-table-sticky ${
                segment === 'us_digital_revenue'
                  ? 'us_digital_revenue-table'
                  : ''
              }`}
              bordered={segment === 'us_digital_revenue' ? 'all' : false}
              addons={[
                groupable({
                  headerGroups: headerGroupList,
                }),
                scrollable({
                  // maxHeight: 650,
                }),
              ]}
            />
            <Pagination
              pageSizeOptions={[defaultPage, 50, 100]}
              onPagingChange={(pageInfo) => handlePagingChange(pageInfo)}
              pageSize={pageSize}
              pageIndex={pageIndex}
              recordCount={loading ? 0 : totalNum}
              pageSizeVisible={totalNum > defaultPage}
              pageIndexVisible={totalNum > defaultPage}
              jumpVisible={totalNum > defaultPage}
              endJumpVisible={totalNum > defaultPage}
              stateText={formatMessage(
                { id: 'dbi_pagination_total' },
                { total: totalNum ?? 0 },
              )}
            />
          </div>
        ) : (
          <div style={{ height: 200 }}>
            <NoData />
          </div>
        )}
      </CardSlotV2>
    </>
  );
};

TableContent.displayName = 'TableContent';

export default TableContent;
